module.exports = __webpack_public_path__ + "img/receipt.904440d3.svg";